<template>
  <div>
    <org-list></org-list>
  </div>
</template>

<script></script>
